module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL2-if-both-wrong.7009f716.mp3";